import React from "react";
import doctorImg from "../images/form_doctor.png";

const Form = () => {
  return (
   <section className="py-16 bg-white font-poppins">
  <div className="max-w-7xl mx-auto px-4 font-poppins">
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
      {/* Left: Form */}
      <div>
        <h2 className="text-[32px] md:text-[36px] lg:text-[48px] font-bold text-[#2A3342] mb-8">
          Book an Appointment
        </h2>

        <form className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="flex flex-col">
            <label className="text-sm md:text-[18px] font-[500] text-[#2A3342] mb-1">
              Name
            </label>
            <input
              type="text"
              placeholder="Enter your full name"
              className="w-full px-4 py-3 rounded-lg border border-slate-200 focus:ring-2 focus:ring-blue-300 outline-none"
            />
          </div>

          <div className="flex flex-col font-poppins">
            <label className="text-sm md:text-[18px] font-[500] text-[#2A3342] mb-1">
              Type of Services
            </label>
            <select className="w-full px-4 py-3 rounded-lg border border-slate-200 focus:ring-2 focus:ring-blue-300 outline-none">
              <option value="">Select</option>
              <option value="service1">General Checkup</option>
              <option value="service2">Consultation</option>
              <option value="service3">Emergency</option>
            </select>
          </div>

          <div className="flex flex-col font-poppins">
            <label className="text-sm md:text-[18px] font-[500] text-[#2A3342] mb-1">
              Email Address
            </label>
            <input
              type="email"
              placeholder="Enter your email address"
              className="w-full px-4 py-3 rounded-lg border border-slate-200 focus:ring-2 focus:ring-blue-300 outline-none"
            />
          </div>

          <div className="flex flex-col font-poppins">
            <label className="text-sm md:text-[18px] font-[500] text-[#2A3342] mb-1">
              Phone Number
            </label>
            <input
              type="tel"
              placeholder="Enter your phone number"
              className="w-full px-4 py-3 rounded-lg border border-slate-200 focus:ring-2 focus:ring-blue-300 outline-none"
            />
          </div>

          <div className="md:col-span-2 flex flex-col font-poppins">
            <label className="text-sm md:text-[18px] font-[500] text-[#2A3342] mb-1">
              Message
            </label>
            <textarea
              placeholder="write your message"
              rows="4"
              className="w-full px-4 py-3 rounded-lg border border-slate-200 focus:ring-2 focus:ring-blue-300 outline-none"
            ></textarea>
          </div>

          <div className="md:col-span-2 font-poppins">
            <button
              type="submit"
              className="w-[280px] bg-[#56C7D5] hover:bg-[#37bfd9] text-white font-[500] px-10 py-3 rounded-lg transition"
            >
              Send message
            </button>
          </div>
        </form>
      </div>

      {/* Right: Image */}
      <div className="flex justify-center lg:justify-end items-start">
        <img
          src={doctorImg}
          alt="Doctors"
          className="w-full max-w-[512px] lg:w-[512px] lg:h-[469px] rounded-2xl object-cover"
        />
      </div>
    </div>
  </div>
</section>

  );
};

export default Form;
